<div class="componentdiv">
    <mat-grid-list cols="1" rowHeight="50px">

        <mat-grid-tile>
            <p>Yournotes use and transfer to any other app of information received from Google APIs will adhere to the <a href="https://developers.google.com/terms/api-services-user-data-policy#additional_requirements_for_specific_api_scopes">Google API Services User Data Policy</a>, including the Limited Use requirements.</p>
        </mat-grid-tile>
        <mat-grid-tile>
            <p>Yournotes only uses the consent on your account to retrieve calendars and (recurring) events, does store the calendar object, but doesn't store the event object itself. Only the 
                event id is used to link a created note to an event.
            </p>
        </mat-grid-tile>

        <mat-grid-tile [rowspan]="10"></mat-grid-tile>
        <mat-grid-tile>
            <mat-toolbar class="bottom-toolbar">
                <button mat-raised-button color="primary" type="button" class="btn btn-default" (click)="back()">Back</button>
              </mat-toolbar>
        </mat-grid-tile>
    </mat-grid-list>

</div>

